var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0c-.474 0-.857.383-.857.857v4.286H.857C.383 5.143 0 5.526 0 6s.383.857.857.857h4.286v4.286c0 .474.383.857.857.857s.857-.383.857-.857V6.857h4.286c.474 0 .857-.383.857-.857s-.383-.857-.857-.857H6.857V.857C6.857.383 6.474 0 6 0z"}));
}

PlusIcon.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
